import { cn } from '@heidi/utils';

import type { ObjectCardVariant } from './object-creation.types';

export const objectCreationCardShell = cn(
  'relative overflow-hidden rounded-lg border border-transparent bg-background-tertiary',
  'transition-all duration-200'
);

/**
 * Variant-2 override — drops the accent fill for the chat surface and a thin
 * subtle border. Append after the shell so `cn`'s tailwind-merge wins over the
 * variant-1 `border-transparent bg-background-tertiary` defaults.
 */
export const objectCreationCardVariantClass = (
  variant: ObjectCardVariant = 'variant-1'
): string | undefined =>
  variant === 'variant-2' ? 'border-border bg-surface' : undefined;

export const objectCreationCardInteractive = cn(
  objectCreationCardShell,
  'group cursor-pointer hover:border-border-hover hover:shadow-sm',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus'
);

export const objectCreationCardStatic = cn(objectCreationCardShell, 'p-4');

export const objectCreationCardActionClass =
  'flex w-fit items-center gap-0.5 text-text-secondary group-hover:text-text-primary';

export const objectCreationIllustrationClass = (
  visible: boolean,
  endClass = 'end-8'
): string =>
  cn(
    'absolute top-4 transition-all duration-300',
    endClass,
    visible
      ? 'translate-y-0 opacity-100 group-hover:scale-105'
      : 'translate-y-4 opacity-0'
  );
